import { render, staticRenderFns } from "./CuposAsignacion.vue?vue&type=template&id=ef1a40bc"
import script from "./CuposAsignacion.vue?vue&type=script&lang=js"
export * from "./CuposAsignacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports